/**
 * GlassCard — universal container surface.
 *
 * Restyled to the 5mi.uz warm pastel design (handoff bundle): white surface,
 * soft border, 22px radius, warm shadow. The "glass" name is kept so the
 * existing pages keep working unchanged.
 *
 * Variants:
 *   - default    plain surface card
 *   - urgent     coral-tinted (used for "Davom etishingiz mumkin")
 *   - dashed     dashed border (empty states)
 *
 * Modifiers:
 *   - hover      adds lift / shadow on hover
 *   - dim        70%-opacity rendering (for expired/locked entries)
 */
import { forwardRef } from 'react'

const VARIANT_STYLE = {
  default: {},
  urgent: { background: 'linear-gradient(135deg, var(--coral-tint), var(--surface))', borderColor: 'var(--coral-soft)' },
  dashed: { borderStyle: 'dashed', background: 'var(--surface-2)', boxShadow: 'none' },
}

const GlassCard = forwardRef(function GlassCard(
  {
    as: As = 'div',
    variant = 'default',
    hover = false,
    dim = false,
    className = '',
    style,
    children,
    ...props
  },
  ref,
) {
  const hoverCls = hover ? 'hover:-translate-y-0.5 hover:shadow-md' : ''
  const dimCls = dim ? 'opacity-70' : ''
  return (
    <As
      ref={ref}
      className={`relative transition-all duration-200 ${hoverCls} ${dimCls} ${className}`}
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 22,
        boxShadow: 'var(--shadow-sm)',
        color: 'var(--ink)',
        ...VARIANT_STYLE[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </As>
  )
})

export default GlassCard
